import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";
import { ScrollWrapper as ScrollWrapperBase } from "@ubnt/store.core/lib/components/ScrollWrapper";

export const TabWrapper = styled.div`
  align-items: stretch;
  display: flex;
  gap: 24px;
  justify-content: center;
  z-index: 3;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 16px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    flex-direction: column;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.neutral11};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.colors.neutral01};
  border-radius: 8px;
  border: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  max-height: 184px;
  max-width: 259px;
  outline: none;
  padding: 8px 0 16px;
  position: relative;
  transition: all 0.2s ease-in-out;
  width: 100%;

  ${({ $isActive }) =>
    $isActive &&
    css`
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      background: ${({ theme }) => theme.colors.neutral00};
    `}

  &:hover {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ImageWrapper = styled.div`
  height: 100%;
  max-height: 140px;
`;

export const TabImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const ActiveIndicator = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.neutral00};
  border-radius: 50%;
  bottom: 0;
  display: flex;
  height: 26px;
  justify-content: center;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 50%);
  width: 26px;

  svg {
    color: ${({ theme }) => theme.colors.neutral11};
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const DeploymentContainer = styled.div`
  margin-top: 8px;
`;

export const DeploymentTypeTab = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const DeploymentLabel = styled.span<{ $isActive: boolean }>`
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.neutral11 : theme.colors.neutral08};
  font-size: 16px;
  font-weight: 400;
  line-height: normal;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding: 6px 15px;
    border: 1px solid
      ${({ $isActive, theme }) =>
        $isActive ? theme.colors.neutral11 : theme.colors.neutral08};
    border-radius: 30px;
  }
`;

export const ScrollWrapper = styled(ScrollWrapperBase)`
  gap: 16px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 8px;
  }
`;
